(() => {
  const teardownLenis = () => {
    if (!window.__aromaLenis) return;
    window.__aromaLenis.destroy();
    window.__aromaLenis = null;
  };

  teardownLenis();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', teardownLenis, { once: true });
  }

  window.addEventListener('load', teardownLenis, { once: true });
})();
